<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="a-nods-as-good-as-a-wink">
<h1 class="unnumbered">A Nod’s As Good As A Wink …</h1>
<p style="text-align: center;">... To A Blind Horse</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3f9ccd94